import fectx from 'axios';

export default fectx;
